import { PRICING_PLAN_APP_DEF_ID, PRICING_PLAN_SECTION_ID } from '../const';
export async function isPricingPlanInstalled(wixCodeApi) {
  if (wixCodeApi.site) {
    if (wixCodeApi.site.isAppSectionInstalled) {
      return Promise.resolve(wixCodeApi.site.isAppSectionInstalled({
        appDefinitionId: PRICING_PLAN_APP_DEF_ID,
        sectionId: PRICING_PLAN_SECTION_ID
      }));
    }
    // TODO: remove when wixCodeApi.site.getAppToken is added to viewerWrapper
    if (wixCodeApi.site.getAppToken) {
      return Promise.resolve(!!wixCodeApi.site.getAppToken(PRICING_PLAN_APP_DEF_ID));
    }
  }
  return isPricingPlanInstalledLegacyMode();
}
async function isPricingPlanInstalledLegacyMode() {
  return new Promise(resolve => {
    if (window.Wix.Utils.getViewMode() !== 'standalone') {
      window.Wix.isAppSectionInstalled(PRICING_PLAN_SECTION_ID, {
        appDefinitionId: PRICING_PLAN_APP_DEF_ID
      }, isInstalled => {
        resolve(isInstalled);
      });
    } else {
      resolve(false);
    }
  });
}
//# sourceMappingURL=isPricingPlanInstalled.js.map